/**
 * 基本配置
 */
const settings = {
  webName: 'SUBO-高新技术企业管理系统',
  webNameEN: 'HIGH-TECH ENTERPRISE MANAGEMENT SYSTEM',
  //测试环境域名
 // baseUrl: 'http://www.shenbao.cc/',

  //苏博版 真实环境域名
  baseUrl: 'http://erdcusapi.shenbaoyuan.com/',

  //在线测试七牛云存储域名
  qnUrl: 'http://sprcc.shenbaoyuan.com/',
  //真实环境七牛云存储域名
  // qnUrl: 'http://rsatssqiniu.shenbaoyuan.com/',
  qnActionUrl: 'https://up-cn-east-2.qiniup.com',
  //localStorage 存储前缀
  storagePrefix: 'region_',
  //路由白名单
  whiteUrl: ['/login', '/admin/company'],
  //临时菜单
  menuUrl: [],
}

export default settings
